/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} User_Detail_Wins_CountInputs */



/**
* | output |
* | --- |
* | "Wins: {count}" |
*
* @param {User_Detail_Wins_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_detail_wins_count = /** @type {((inputs: User_Detail_Wins_CountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Detail_Wins_CountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Victoires : ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Victorias: ${i?.count}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Vitórias: ${i?.count}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Vittorie: ${i?.count}`)
	return /** @type {LocalizedString} */ (`Wins: ${i?.count}`)
});